define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/property/addresses'
	});
});
